// extracted by mini-css-extract-plugin
module.exports = {"timer-container":"waiting_timer-container__bGGmD","container":"waiting_container__XqvwI"};